export default __webpack_public_path__ + "static/media/rs_school_js.db2798bd.svg";